// Giai đoạn đầu tư
export default {
  PrepareInvest: 0, //'Giai đoạn chuẩn bị đầu tư',
  PerformInvest: 1, //'Giai đoạn thực hiện đầu tư',
  EndInvest: 2, //'Giai đoạn kết thúc xây dựng, đưa dự án vào khai thác sử dụng',
  Costs: 3, //'Chi phí Ban quản lý dự án',
};
